import Vue from 'vue';
import App from './App.vue';
import store from './store';
import i18n from './i18n';
import router from './router';
import Vuebar from 'vuebar';
import VueScrollTo from 'vue-scrollto';
import VueMeta from 'vue-meta';
import moment from 'moment';
import 'moment/locale/de-ch';

moment().locale('de-ch');

Vue.config.productionTip = false;

Vue.use(Vuebar);
Vue.use(VueScrollTo);
Vue.use(VueMeta, {
    refreshOnceOnNavigation: true
});

new Vue({
  router,
  render: h => h(App),
  store,
  i18n,
}).$mount('#app');
